var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneLevelUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".canvas{fill: none; opacity: 0;}.light-yellow-10{fill: #996f00; opacity: 0.1;}.light-yellow{fill: #996f00; opacity: 1;}.light-blue{fill: #005dba; opacity: 1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconLightOneLevelUp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "canvas",
    className: "canvas"
  }, /*#__PURE__*/React.createElement("path", {
    className: "canvas",
    d: "M16,16H0V0H16Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "level-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "light-yellow-10",
    d: "M8.5,3.5l-1-1h-6V9.38l.5-.5L3.73,7.15H5.27l3.5,3.5L6.92,12.5H14.5v-9ZM6,12.12v.38h.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light-yellow",
    d: "M14.5,3H8.71l-.86-.85L7.5,2h-6L1,2.5V9.88l1-1V5H7.48l.35-.15L8.68,4H14v8H7.42l-1,1H14.5l.5-.5v-9ZM7.27,4H2V3H7.29l.49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light-blue",
    d: "M6.646,11.353,5,9.707V15H4V9.707L2.354,11.353l-.708-.707,2.5-2.5h.708l2.5,2.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLevelUp);
export default __webpack_public_path__ + "static/media/OneLevelUp.b3f816442e0264498a4c658c06bdb6b5.svg";
export { ForwardRef as ReactComponent };